<template>
  <div id="clueStaffCircConfigure" class="common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">角色：</div>
          <div class="content">
            <el-select
              v-model="form.role"
              placeholder="请选择"
              @change="roleChange"
            >
              <el-option
                v-for="(item,index) in roleList"
                :key="index"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">大区：</div>
          <div class="content">
            <el-select
              v-model="form.bigArea"
              placeholder="请选择"
              @change="bigAreaChange"
              clearable
            >
              <el-option
                v-for="(item,index) in bigAreaList"
                :key="index"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">区域：</div>
          <div class="content">
            <el-select
              v-model="form.region"
              clearable
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="regionRemoteMethod"
              :loading="regionLoading"
              @focus="regionFocusHandle"
            >
              <el-option v-for="(item, index) in regionList" :key="index" :label="item" :value="item" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">审核人：</div>
          <div class="content">
            <el-select
              v-model="form.userId"
              clearable
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="userRemoteMethod"
              :loading="userLoading"
              @focus="userFocusHandle"
            >
              <el-option v-for="(item, index) in userList" :key="index" :label="item.userName" :value="item.userName" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button plain @click="reset">重置</el-button>
          <el-button type="primary" @click="searchBtn">搜索</el-button>
        </div>
      </el-row>
    </div>
    <div class="common_btnBar">
      <el-button type="primary" @click="addHandlen">添加</el-button>
    </div>
    <commonTable ref="clueStaffCircConfigureTable" />
    <addReviewerDialog
      @reviewerSubmit="reviewerSubmit"
      @dialogCloseHandle="reviewerDialogClose"
      :reviewer-dialog-visible="reviewerDialogVisible"
      :big-area-list="bigAreaList"
      :row-data="rowData"
    />
  </div>
</template>
<script>
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions';
import { clueStaffCircConfigureApi } from './service';
import addReviewerDialog from './component/clueStaffCircConfigure/addReviewerDialog';

export default {
  data () {
    return {
      form: {
        role: '内销'
      },
      tableData: [],
      roleList: ['内销', 'IMC'],
      bigAreaList: [],
      regionList: [],
      regionLoading: false,
      reviewerDialogVisible: false,
      userLoading: false,
      userList: [],
      rowData: {}
    };
  },
  components: {
    commonTable,
    addReviewerDialog
  },
  computed: {},
  methods: {
    roleChange () {
      this.$set(this.form, 'userId', '');
      this.userList = [];
    },
    editHandle (row) {
      this.rowData = JSON.parse(JSON.stringify(row));
      this.reviewerDialogVisible = true;
    },
    userFocusHandle () {
      if (!this.form.role) {
        this.$message.error('请选择角色');
      }
    },
    userRemoteMethod (query) {
      if (query && this.form.role) {
        let params = {
          role: this.form.role,
          keyWord: query
        };
        clueStaffCircConfigureApi.getAdminList(params).then(res => {
          if (res.status === '200') {
            this.userList = res.data;
          }
        });
      }
    },
    bigAreaChange () {
      this.$set(this.form, 'region', '');
      this.regionList = [];
    },
    regionFocusHandle () {
      if (!this.form.bigArea) {
        this.$message.error('请选择大区');
      }
    },
    regionRemoteMethod (query) {
      if (query && this.form.bigArea) {
        clueStaffCircConfigureApi.getRegionList({ bigArea: this.form.bigArea, keyWord: query }).then(res => {
          if (res.status === '200') {
            this.regionList = res.data;
          }
        });
      } else {
        this.regionList = [];
      }
    },
    getBigAreaList () {
      clueStaffCircConfigureApi.getBigAreaList().then(res => {
        if (res.status === '200') {
          this.bigAreaList = res.data;
        }
      });
    },
    deleteHandle (row) {
      this.$confirm('确定删除该审核人?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          bigArea: row.bigArea,
          region: row.region,
          role: row.role
        };
        this.$store.commit('setSubPageLoading', true);
        clueStaffCircConfigureApi.reviewerDelete(params).then(res => {
          if (res.status === '200') {
            this.searchBtn();
            this.$message.success('删除成功');
          }
          this.$store.commit('setSubPageLoading', false);
        });
      }).catch(() => {

      });
    },
    reviewerDialogClose () {
      this.rowData = {};
      this.reviewerDialogVisible = false;
    },
    reviewerSubmit () {
      this.reviewerDialogVisible = false;
      this.searchBtn();
    },
    addHandlen () {
      this.reviewerDialogVisible = true;
    },
    reset () {
      this.form = { role: '内销' };
      this.searchBtn();
    },
    searchBtn () {
      this.$refs.clueStaffCircConfigureTable.pageData.pageNum = 1;
      this.$refs.clueStaffCircConfigureTable.loadTable({
        url: '/lead/option_config/sea_distribution/list',
        listKey: 'list',
        params: this.form
      });
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('大区')
          ._width('140px')
          ._data('bigArea')
      );
      tableRow.push(
        new TableColumns()
          ._title('区域')
          ._width('140px')
          ._data('region')
      );
      tableRow.push(
        new TableColumns()
          ._title('角色')
          ._width('140px')
          ._data('role')
      );
      tableRow.push(
        new TableColumns()
          ._title('审核人')
          ._width('140px')
          ._data('userName')
      );
      tableRow.push(
        new TableColumns()
          ._title('最近更新人')
          ._width('160px')
          ._data('modifyUser')
      );
      tableRow.push(
        new TableColumns()
          ._title('最近更新时间')
          ._width('140px')
          ._data('modifyTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = row[column.property] ? new Date(row[column.property].replace(/-/g, '/')).format('yyyy-MM-dd') : '';
              return (
                <span>{ date }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('150px')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => {
                    this.editHandle(row);
                  }}>编辑
                  </el-button>
                  <el-button type="text" onClick={() => {
                    this.deleteHandle(row);
                  }}>删除
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.clueStaffCircConfigureTable.setColumn(column);
      this.$refs.clueStaffCircConfigureTable.loadTable({
        url: '/lead/option_config/sea_distribution/list',
        listKey: 'list',
        params: this.form
      });
    }
  },
  mounted () {
    this.getBigAreaList();
    this.loadTable();
  }
};
</script>
<style lang="scss" scoped>

</style>
